import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useClient, useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import query from './query.graphql.js'
import deleteMutation from './mutation-delete.graphql.js'
import copyMutation from './mutation-copy.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let onCopy = useOnCopy(props)
  let onDelete = useOnDelete(props)

  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'copy':
        return onCopy({ value, originalValue, args, change })
      case 'delete':
        return onDelete({ value, originalValue, args, change })
      default:
        return
    }
  }
}

function useOnCopy(props) {
  let [, notify] = useNotifications()
  let client = useClient()
  let [, executeMutation] = useMutation(copyMutation)

  return async function onSubmit({ value, originalValue, args, change }) {
    let response = await client
      .query(query, { location_ids: args.location_ids })
      .toPromise()
    let objects = response.data.vaxiom_sys_organizations
      .map(organization => organization.id)
      .map(organization_id => ({
        name: value.name,
        description: value.description,
        requires_diagnosis: value.requires_diagnosis,
        requires_images: value.requires_images,
        // cannot copy the selected charges since those are by location
        organization_id,
      }))
    let mutationResponse = await executeMutation({
      objects,
    })
    if (mutationResponse.error) {
      notify(notifyError('An error has occurred while copying procedure.'))
      return
    }

    notify(notifySuccess('Procedure has been copied to target locations.'))
  }
}

function useOnDelete(props, data) {
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(deleteMutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    let mutationResponse = await executeMutation({
      id: value.id,
    })
    if (mutationResponse.error) {
      notify(notifyError(`An error has occurred while deleting procedure.`))
      return
    }

    notify(notifySuccess(`Procedure deleted successfully.`))

    setFlowTo(normalizePath(props.viewPath, 'ActionsAction/Delete/No'))
  }
}
